import axios from '../utils/axios'
import API from '../api'
import storeData from '../store/index.js'
import qs from 'qs'

// axios.defaults.baseURL = 'https://dudao.tianwangwatch.cn'
// axios.defaults.headers.common['token'] = storeData.token;
// axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.headers.get['Content-Type'] = 'application/json';

// 获取code
export  function getCode(){
    return new Promise((resolve, reject) => {
        console.log(';asasasas')
        axios({
            url: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww5f1917dc1e451a6e&redirect_uri=http%3a%2f%2fdudao.tianwangwatch.cn%2fgetCode.html&response_type=code&scope=snsapi_base&agentid=1000004#wechat_redirect',
            // url: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww36b68b5038757ccc&redirect_uri=https%3a%2f%2fdudao.tianwangwatch.cn%2ftwb_api%2fauth%2fOAuthNotify&response_type=code&scope=snsapi_base&agentid=1000002#wechat_redirect',            
            method: 'get'
        })
        .then(data => {
            // if (status != 200) {
            //     return;
            // }
            // resolve(data);
            console.log("111",data)
        })
        .catch(error => {
            // alert('发送失败');
            console.log("v",error);
        })
    })
}

// 获取企业微信签名
export function getSign(params) {
    return new Promise((resolve,reject)=>{
        axios({
            url: '/twb_api/auth/configSet',
            params:{
                url: params
            }
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error);
        })
    })
    
}

// 更新用户信息
export function UpdataUserInfo(){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.UpdataUserInfo_api,
            method: "GET",
            headers:{
                token: storeData.token
            }
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error)
        })
    })
}

// 初始化用户资料
export function initUserData(){
    return new Promise((resolve, reject) => {
        axios({
            url: API.InitUserData_api,
            method: 'GET',
            headers: {
                token: storeData.token,
                'Content-Type': 'application/json'
            }
        })
        .then(data => {
            // console.log(data)
            resolve(data);
        })
        .catch(error => {
            // alert('发送失败');
        })
    })
}

// 完善个人资料
export function completeInfo (userInfo){
    return new Promise((resolve, reject) => {
        axios({
            url: API.CompleteInfo_api,
            method: 'POST',
            headers:{
                token: storeData.token,
                'Content-Type': 'application/x-www-from-urlencoded'
            },
            params: userInfo
        })
        .then(data => {
            // console.log(data)
            resolve(data);
        })
        .catch(error => {
            console.log(error);
            // alert('发送失败');
        })
    })
}

// 积分排名弹窗
export function IntegralRanking(){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.IntegralRanking_api,
            method: 'GET',
            headers:{
                'Content-Type': 'application/json',
                token: storeData.token
            },
            params:{
                pageNo:1,
                pageSize:3
            }
        })
        .then(data => {
            // console.log(data)
            resolve(data);
        })
        .catch(error => {
            // alert('发送失败');
        })
    })
}

// 课程列表
export function getCourseList(parmas){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetCourseList_api,
            method: 'GET',
            headers: {
                token: storeData.token
            },
            params: parmas
        }).then(data=>{
            // console.log(data)
            if(data.data.code == 200){
                resolve(data)
            } else {
                reject();
            }
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 课程详情
export function getCourseInfo(courseId){ 
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetCourseInfo_api,
            method: 'GET',
            headers: {
                'Content-Type':'application/json',
                token: storeData.token
            },
            params: {
                courseId: courseId
            }
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 切换视频清晰度
export function ChangeVideoArticulation(params){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.ChangeVideoArticulation_api,
            method: 'GET',
            params: params
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error)
        })
    })
}


// 专题考试题目类型
export function GetThematicType(params){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetThematicType_api,
            method: 'GET',
            headers: {
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 获取管理公告列表
export function GetManageList(params){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetManageList_api,
            method: 'GET',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 获取管理公告详情
export function GetManageDetail(maId){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetManageDetail_api,
            method:'GET',
            headers:{
                token: storeData.token
            },
            params:{
                maId: maId
            }
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 获取专题练习题目列表
export function GetSubjectList(params){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetSubjectList_api,
            method: "GET",
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error)
        })
    })
}

// 错题入错题集
export function PostErrorSubject(params){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.PostErrorSubject_api,
            method: 'POST',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 错题出错题集
export function ErrorSubOutList(params) {
    return new Promise((resolve, reject)=>{
        axios({
            url: API.ErrorSubOutList_api,
            method:'POST',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 获取错题类型列表
export function GetErrorSubjectTypeList(parmas){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.GetErrorSubjectTypeList_api,
            method:'GET',
            headers:{
                token: storeData.token
            },
            params: parmas
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error)
        })
    })
}

// 获取专题练习题目列表
export function GetErrorSubjectList(params){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetErrorSubjectList_api,
            method: "GET",
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error)
        })
    })
}

// 获取年度考试试卷
export function GetNdExam(){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.GetNdExam_api,
            method: 'POST',
            headers:{
                token: storeData.token
            }
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error)
        })
    })
}

// 提交年度考试试卷
export function PostCommitNdExam(params){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.PostCommitNdExam_api,
            method: 'POST',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 获取综合考试试卷
export function GetZhExam(){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.GetZhExam_api,
            method: 'POST',
            headers:{
                token: storeData.token
            }
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error)
        })
    })
}

// 提交综合考试试卷
export function PostCommitZhExam(params){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.PostCommitZhExam_api,
            method:'POST',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 上传头像
export function UploadFile(formData){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.UploadFile_api,
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                token: storeData.token
            },
            data: formData
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 保存修改资料
export function SaveUserInfo(params){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.SaveUserInfo_api,
            method: 'POST',
            headers: {
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 个人中心(我的课程)
export function GetMyCourseList(params){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetMyCourseList_api,
            method: 'GET',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 个人中心(我的考核)
export function GetMyExamList(params){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.GetMyExamList_api,
            method:"GET",
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 个人中心(我的考核明细)
export function GetExamDetail(params){
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetExamDetail_api,
            method: 'GET',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 个人中心(我的积分)
export function GetMyIntegralList(params) { 
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetMyIntegralList_api,
            method:'GET',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 个人中心(排行榜)
export function GetIntegralRanking(params) {
    return new Promise((resolve, reject)=>{
        axios({
            url: API.GetIntegralRanking_api,
            method: 'GET',
            headers: {
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data)
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 获取积分说明及使用说明
export function GetInstructions(params){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.GetInstructions_api,
            method:'GET',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error)
        })
    })
}

// 获取表情类型
export function GetFaceScore(){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.GetFaceScore_api,
            method: 'GET',
            headers:{
                token: storeData.token
            }
        }).then(data=>{
            console.log(data);
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 记录在线时长
export function GetOnlineTime(params){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.GetOnlineTime_api,
            method: 'POST',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            console.log(data);
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 记录专题练习记录
export function PostExercise(params){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.PostExercise_api,
            method: 'POST',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 专题练习答题板切换中间还有没答题目,后台记录
export function SaveSubjectRecordByChoose(params){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.SaveSubjectRecordByChoose_api,
            method:'POST',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 排行榜设置
export function GetRankSetting(){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.GetRankSetting_api,
            method:'GET',
            headers:{
                token: storeData.token
            }
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}

// 记录专题;练习的次数
export function SaveSubjectSubmitCount(params){
    return new Promise((resolve,reject)=>{
        axios({
            url: API.SaveSubjectSubmitCount_api,
            method:'POST',
            headers:{
                token: storeData.token
            },
            params: params
        }).then(data=>{
            resolve(data);
        }).catch(error=>{
            console.log(error);
        })
    })
}


// WEBPACK FOOTER //
// ./src/service/index.js